import React, { useState } from "react";
import { Grid, Card, Icon, Text, InlineStack } from "@shopify/polaris";
import { ArrowRightIcon, ArrowLeftIcon } from "@shopify/polaris-icons";
// import styles from "../../styles/components/Cards/card.module.css";

const InventoryCard = ({ inventory }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === inventory.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? inventory.length - 1 : prevIndex - 1
    );
  };

  const currentItem = inventory[currentIndex];

  return (
    <>
      <Grid.Cell columnSpan={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}>
        <Card>
          <Text as="p" variant="bodyMd">
            {/* Total Boxes Available for */}
          </Text>
          <Text variant="headingXl" as="h3">
            {currentItem.remaining}
          </Text>
          <InlineStack gap={"100"}>
            <div onClick={handlePrevious}>
              <Icon source={ArrowLeftIcon} tone="base" />
            </div>{" "}
            <div> {currentItem?.box?.name ?? "Box"}</div>
            <div
              onClick={() => {
                handleNext();
              }}
            >
              <Icon source={ArrowRightIcon} tone="base" />
            </div>
          </InlineStack>
        </Card>
      </Grid.Cell>
    </>
  );
};

export default InventoryCard;
